module.exports = __webpack_public_path__ + "static/media/proj6_img1.4e5872c0.jpg";